<template>
    <flex-container justify-content="space-between" :padding-bottom="Size.xl">
        <flex-container :size="6">
            <text-decorator weight="bold">
                AI Agent
            </text-decorator>
            <flex-container align-items="center">
                <text-decorator :size="FontSize.lg" weight="bold">
                    {{ description }}
                </text-decorator>
            </flex-container>
        </flex-container>
        <flex-container
            justify-content="flex-end"
            align-content="center"
            :size="4"
        >
            <button-block
                :disabled="disabled"
                @loading="(event) => emit('save', event)"
            >
                Opslaan
            </button-block>
            <flex-container size="auto">
                <input-group v-model="isActive">
                    <template #input>
                        <switch-input />
                        <text-decorator :size="FontSize.xs">
                            {{ isActive ? 'Actief' : 'Inactief' }}
                        </text-decorator>
                    </template>
                </input-group>
            </flex-container>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import {
        ButtonBlock,
        type ButtonStateChangedEvent,
        FlexContainer,
        FontSize,
        InputGroup, Size,
        SwitchInput,
        TextDecorator,
    } from '@keyvue/one-ui';

    import { ref, watch } from 'vue';

    const props = defineProps<{
        description: string;
        isActive: boolean;
        disabled: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'save', event: ButtonStateChangedEvent): void;
        (e: 'activate'): void;
        (e: 'deactivate'): void;
    }>();

    const description = ref(props.description);
    const isActive = ref(props.isActive);

    watch(isActive, (newValue) => {
        if (newValue) {
            emit('activate');
        } else {
            emit('deactivate');
        }
    });
</script>

<style scoped lang="scss">
.button-default {
    color: var(--theme-colors-default--primary);
}
</style>
